import type { TextEllipsisProps } from "./text-ellipsis.type";

import { Tooltip, Typography } from "antd";

import { truncate } from "@/utilities/string";

const { Text } = Typography;

export const TextEllipsis = ({
  text,
  length,
  strong,
  className,
}: TextEllipsisProps) => {
  const props = { strong, className };

  if (text.length <= length) {
    <Text {...props}>{text}</Text>;
  }

  return (
    <Tooltip title={text}>
      <Text {...props}>{truncate(text, length)}</Text>
    </Tooltip>
  );
};
